import React, { useState } from 'react';
import { X, Check } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const BundleCustomizer = ({ bundlePackage, products, onConfirm, onClose }) => {
  const [selectedProducts, setSelectedProducts] = useState([]);

  const toggleProduct = (product) => {
    if (selectedProducts.find(p => p.id === product.id)) {
      setSelectedProducts(selectedProducts.filter(p => p.id !== product.id));
    } else {
      if (selectedProducts.length < bundlePackage.quantity) {
        setSelectedProducts([...selectedProducts, product]);
      }
    }
  };

  const isSelected = (productId) => {
    return selectedProducts.some(p => p.id === productId);
  };

  const handleConfirm = () => {
    if (selectedProducts.length === bundlePackage.quantity) {
      onConfirm({
        package: bundlePackage,
        products: selectedProducts
      });
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content bundle-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div>
            <h2>Customize Your {bundlePackage.name}</h2>
            <p className="modal-subtitle">
              Select {bundlePackage.quantity} {bundlePackage.quantity === 1 ? 'product' : 'products'} for your bundle
            </p>
          </div>
          <button className="modal-close" onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        <div className="bundle-selection-info">
          <div className="selection-count">
            <span className="count-badge">{selectedProducts.length}</span>
            <span className="count-text">of {bundlePackage.quantity} selected</span>
          </div>
          <div className="bundle-price">
            <span className="price-label">Total:</span>
            <span className="price-value">₹{bundlePackage.price}</span>
            {bundlePackage.savings > 0 && (
              <span className="savings-badge">Save ₹{bundlePackage.savings}</span>
            )}
          </div>
        </div>

        <div className="bundle-products-grid">
          {products.map((product) => {
            const selected = isSelected(product.id);
            const canSelect = selectedProducts.length < bundlePackage.quantity;
            
            return (
              <Card 
                key={product.id} 
                className={`bundle-product-card ${
                  selected ? 'selected' : ''
                } ${
                  !selected && !canSelect ? 'disabled' : ''
                }`}
                onClick={() => toggleProduct(product)}
              >
                <CardContent className="bundle-product-content">
                  {selected && (
                    <div className="selection-badge">
                      <Check size={16} />
                    </div>
                  )}
                  <div className="bundle-product-image-wrapper">
                    <img 
                      src={product.images[0]} 
                      alt={product.name}
                      className="bundle-product-image"
                    />
                    <div className="bundle-product-icon">{product.icon}</div>
                  </div>
                  <h4 className="bundle-product-name">{product.name}</h4>
                  <p className="bundle-product-desc">{product.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="bundle-modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button 
            className="btn-primary btn-cta"
            onClick={handleConfirm}
            disabled={selectedProducts.length !== bundlePackage.quantity}
          >
            Add Bundle to Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default BundleCustomizer;